/* (c) Copyright Frontify Ltd., all rights reserved. */

export const Z_INDEX_TOOLTIP = 1400;
export const Z_INDEX_MODAL = 1200;
export const Z_INDEX_MODAL_BACKDROP = 1100;
export const Z_INDEX_POPOVER = 1000;
